export default __webpack_public_path__ + "static/media/mt6.07d7feec.png";